import { useApi } from '#shared/providers/Api';
import useUsers from '../useUsers';
import unwrap from '../unwrap';
import { RolePayload } from '../types';

// The role endpoints take the permission keys as one comma-separated string.
function toRoleRequest(role: RolePayload) {
  return { ...role, Permissions: role.Permissions.join(',') };
}

export default function useUpdateRole() {
  const api = useApi();
  const { account } = useUsers();

  async function updateRole(role: RolePayload & { RoleID: number }) {
    const { RoleID, ...rest } = role;

    return unwrap(api.postUpdateAccountUserRole({ RoleID, ...toRoleRequest(rest) }, undefined, account.bearer));
  }

  return { updateRole };
}
